export default __webpack_public_path__ + "static/media/menu5_hl.14af282b.png";